import { useId } from 'react';

/** Edits a token-count param as characters, showing the live characters→tokens conversion. */
export function CharTokenRow({
	label,
	tokens,
	charsPerToken,
	onChange,
}: {
	label: string;
	tokens: number;
	charsPerToken: number;
	onChange: (tokens: number) => void;
}) {
	const inputId = useId();
	const characters = Math.round(tokens * charsPerToken);
	return (
		<div
			style={{
				display: 'flex',
				flexWrap: 'wrap',
				justifyContent: 'space-between',
				alignItems: 'center',
				gap: 10,
				marginBottom: 6,
			}}
		>
			<label htmlFor={inputId} style={{ fontSize: 12, color: '#111' }}>
				{label}
			</label>
			<div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center', gap: 6 }}>
				<input
					id={inputId}
					type="number"
					min={1}
					step={1}
					value={characters}
					onChange={(e) => {
						// Store the exact character count as tokens (chars ÷ charsPerToken) so any
						// value is accepted — no snapping to multiples of charsPerToken.
						const c = Math.max(1, Math.round(Number(e.target.value) || 1));
						onChange(c / charsPerToken);
					}}
					style={{
						width: 90,
						fontSize: 13,
						padding: '4px 6px',
						border: '.5px solid #ddd',
						borderRadius: 6,
						textAlign: 'right',
						boxSizing: 'border-box',
					}}
				/>
				<span style={{ fontSize: 10, color: '#888' }}>characters</span>
				<span style={{ fontSize: 11, color: '#111', fontWeight: 600, minWidth: 72, textAlign: 'right' }}>
					≈ {(Math.round(tokens * 100) / 100).toLocaleString()} tokens
				</span>
			</div>
		</div>
	);
}
